import classnames from "classnames"

import styles from "./diy_tanda_selected.module.scss"

interface Props {
  disabled?: boolean
  label: "if" | "then"
  onClick: () => void
}

export default function DIYTandaSelect({ label, disabled = false, onClick }: Props) {
  const placeholder = label == "if" ? "this" : "that"

  return (
    <section
      className={classnames(styles["tanda-select-block"], {
        [styles.disabled]: disabled,
        [styles["then-that"]]: placeholder === "that",
      })}
      onClick={disabled ? () => {} : onClick}
    >
      <span className={styles.label}>
        {label} {placeholder}
      </span>
      <button className="button-tertiary button-on-color">Add</button>
    </section>
  )
}
